import { dateFormatBackend } from '@/modules/_global/filters';

export default {
  setHolidays: (state, holidays) => {
    holidays.forEach(function(item) {
      if (!state.holidays.includes(item)) {
        state.holidays.push({ ...item, date: dateFormatBackend(item.date) });
      }
    });
  }
};
